import { Flex } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { Commitments } from './Commitments';
import { PricingOptions } from './PricingOptions';
import { StickyHeaderSection } from '~/packages/common-frontend/components/StickyHeaderSection';
import { Typography } from '~/packages/common-frontend/components/Typography';

type LoanMechanicsProps = {
  loanMechanics: CreditAgreement.DomainEntity.CreditAgreementFullArtifact['loanMechanicsV1'];
};

export const LoanMechanics = ({ loanMechanics }: LoanMechanicsProps) => {
  if (!loanMechanics) {
    return null;
  }

  const { commitments, loans, pricingOptions } = loanMechanics;

  return (
    <StickyHeaderSection labelText="Loan Mechanics">
      <Flex
        mt="40px"
        flexDirection="column"
        alignContent="flex-start"
        gap="2em"
        w="100%"
      >
        <Flex flexDirection="column" alignContent="flex-start" gap="2em">
          <Typography variant="section-title">Pricing Options</Typography>
          <PricingOptions pricingOptions={pricingOptions} />
        </Flex>
        <Flex flexDirection="column" alignItems="flex-start" gap="2em" w="100%">
          <Typography variant="section-title">Commitments</Typography>
          <Commitments
            commitments={commitments}
            loans={loans}
            pricingOptions={pricingOptions}
          />
        </Flex>
      </Flex>
    </StickyHeaderSection>
  );
};
